/**
 * Planning model → week count.
 *
 * The actual section/step structure is stored per planning template
 * (see `src/utils/planning_structure.ts` for read helpers).
 */
export const MODEL_WEEK_COUNTS: Record<string, number> = {
  "10_mois_avec_conges": 44,
  "11_mois": 48,
  "12_mois": 52,
  "12_mois_ordre": 52,
  "13_mois_avec_conges": 56,
  "14_mois_avec_conges": 60,
  "15_mois_avec_conges": 64,
  "16_mois_avec_conges": 68,
  "17_mois_avec_conges": 72,
  "18_mois_avec_conges": 76,
};
